import { Statistic } from "antd";
import { AuctionResponse } from "../../../types";
import { format } from "date-fns";
import { useAppSelector } from "../../../../../redux/Hooks";
import { AuctionMethodCode, AuctionTypeCode, preCostTypes, registerTypes } from "../../../../common/types/types";

interface AuctionItemDetailProps {
    product?: AuctionResponse,
}

const AuctionItemDetail = ({ product }: AuctionItemDetailProps) => {
    const userState = useAppSelector(state => state.login);
    const auctionState = useAppSelector(state => state.auction);

    return (
        <div className="list-details" style={{ marginTop: '30px' }}>
            {product?.statute?.auctionMethod?.code === AuctionMethodCode.INCREASE ?
                <div style={{ display: 'flex' }}>
                    <span>Bước giá:</span>
                    <span style={{ fontWeight: 'bold', display: 'flex', marginLeft: 5 }}>
                        <Statistic
                            value={product?.biddingCostPerBid || 0}
                            groupSeparator="."
                            decimalSeparator=","
                            precision={0}
                            style={{ marginRight: 5 }}
                            valueStyle={{ fontSize: 14, fontFamily: 'Quicksand' }} /> VNĐ
                    </span>
                </div> : <></>}

            {product?.statute?.auctionMethod?.code === AuctionMethodCode.DECREASE ?
                <div style={{ display: 'flex' }}>
                    <span>Mức giá giảm:</span>
                    <span style={{ fontWeight: 'bold', display: 'flex', marginLeft: 5 }}>
                        <Statistic
                            value={product?.biddingDownPerTurn || 0}
                            groupSeparator="."
                            decimalSeparator=","
                            precision={0}
                            style={{ marginRight: 5 }}
                            valueStyle={{ fontSize: 14, fontFamily: 'Quicksand' }} /> VNĐ
                    </span>
                </div> : <></>}

            <div style={{ display: 'flex' }}>
                <span>Tiền đặt trước:</span>
                <span style={{ fontWeight: 'bold', display: 'flex', marginLeft: 5 }}>
                    <Statistic
                        value={product?.preCost || 0}
                        groupSeparator="."
                        decimalSeparator=","
                        precision={0}
                        style={{ marginRight: 5 }}
                        valueStyle={{ fontSize: 14, fontFamily: 'Quicksand' }} /> VNĐ
                </span>
            </div>
            <div>
                <span>Thời gian đăng ký tham gia:</span>
                <span style={{ fontWeight: 'bold', marginLeft: 5 }}>
                    {product?.statute?.startRegistrationDate && product?.statute?.endRegistrationDate ?
                        `Từ ${format(product?.statute?.startRegistrationDate, "HH:mm:ss dd/MM/yyyy")} đến ${format(product?.statute?.endRegistrationDate, "HH:mm:ss dd/MM/yyyy")}` :
                        ""
                    }
                </span>
            </div>
            <div>
                <span>Thời gian nộp tiền đặt trước:</span>
                <span style={{ fontWeight: 'bold', marginLeft: 5 }}>
                    {product?.statute?.startPrePaymentDate && product?.statute?.endPrePaymentDate ?
                        `Từ ${format(product?.statute?.startPrePaymentDate, "HH:mm:ss dd/MM/yyyy")} đến ${format(product?.statute?.endPrePaymentDate, "HH:mm:ss dd/MM/yyyy")}` :
                        ""
                    }
                </span>
            </div>
            <div>
                <span>Hình thức đấu giá trực tuyến:</span>
                <span style={{ fontWeight: 'bold', marginLeft: 5 }}>{product?.statute?.auctionType?.name || ""}
                </span>
            </div>
            <div>
                <span>Phương thức trả giá:</span>
                <span style={{ fontWeight: 'bold', marginLeft: 5 }}>{product?.statute?.auctionMethod?.name || ""}</span>
            </div>
            {product?.statute?.auctionType?.code !== AuctionTypeCode.HAVE_ROUND ?
                <div>
                    <span>Thời gian trả giá:</span>
                    <span style={{ fontWeight: 'bold', marginLeft: 5 }}>{product?.statute?.timePerProduct || product?.statute?.timePerPriceDown || 0} phút</span>
                </div>
                :
                <>
                    <div>
                        <span>Số vòng đấu giá:</span>
                        <span style={{ fontWeight: 'bold', marginLeft: 5 }}>{product?.statute?.totalRound || 0} vòng</span>
                    </div>
                    <div>
                        <span>Thời gian mỗi vòng đấu giá:</span>
                        <span style={{ fontWeight: 'bold', marginLeft: 5 }}>{product?.statute?.incrementInTimePerBid || 0} phút</span>
                    </div>
                </>

            }
            {product?.bidderResponseDTO?.registerStatus !== -1 && product?.bidderResponseDTO ?
                <div>
                    <span>Tình trạng đăng ký:</span>
                    {!product?.bidderResponseDTO?.isActive && !auctionState.skippedRound ?
                        <>
                            {userState?.user?.userId && (product?.bidderResponseDTO?.registerStatus === registerTypes.SUBMIT || product?.bidderResponseDTO?.registerStatus === registerTypes.SUCCESS) &&
                                (product?.bidderResponseDTO.preCostStatus === preCostTypes.NOTPAY || product?.bidderResponseDTO.preCostStatus === preCostTypes.FAILED) ?
                                <span style={{ fontWeight: 'bold', marginLeft: 5, color: '#8FB12C' }}>Đã đăng ký. Chưa nộp tiền đặt trước</span> : <></>}
                            {product?.bidderResponseDTO?.preCostStatus === preCostTypes.WAITING ?
                                <span style={{ fontWeight: 'bold', marginLeft: 5, color: '#E59F17' }}>Chờ đối soát</span> : <></>}
                            {product?.bidderResponseDTO?.preCostStatus === preCostTypes.DONE && !product?.bidderResponseDTO.isActive &&
                                (product?.bidderResponseDTO?.registerStatus === registerTypes.SUCCESS || product?.bidderResponseDTO?.registerStatus === registerTypes.SUBMIT) ?
                                <span style={{ fontWeight: 'bold', marginLeft: 5, color: '#8FB12C' }}>Đăng ký thành công</span> : <></>}
                            {product?.bidderResponseDTO?.registerStatus === registerTypes.INVALID ?
                                <span style={{ fontWeight: 'bold', marginLeft: 5, color: 'red' }}>Đăng ký không hợp lệ</span> : <></>}
                        </> : <span style={{ fontWeight: 'bold', marginLeft: 5, color: 'red' }}>Bạn đã bị truất quyền</span>}
                </div> : <></>}
        </div>
    )
}

export default AuctionItemDetail;